import { render, staticRenderFns } from "./TabRelease.vue?vue&type=template&id=5ccde0e3"
import script from "./TabRelease.vue?vue&type=script&lang=js"
export * from "./TabRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports